import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';

import { QUOTE_BLOCK } from '../constants';
import type { QuoteBlockElement } from '../types';

/** Create a Wrex quote element */
export function createQuote(children: QuoteBlockElement['children'] = [createParagraph()]): QuoteBlockElement {
    return { type: QUOTE_BLOCK, children };
}
